// assets/js/components/revenue-calculator/steps/lead-gate.js
var ui = require("../ui");
var data = require("../data");
var validate = require("../validate");

function render(state) {
    var d = state.d;
    var isSMB = d.bookingSystem === "SimplyBook.me";
    var html = '<div class="rc-calc__eyebrow">' + _t("Almost there") + "</div>" +
        ui.h2(_t("See your full revenue report")) +
        ui.sub(_t("We'll show your results on the next screen and send you a copy by email."));

    html += ui.field({
        id: "rc-first-name", label: _t("First name"),
        inner: ui.textInput({ id: "rc-first-name", value: state.firstName, placeholder: _t("Your first name") })
    });
    html += ui.field({
        id: "rc-email", label: _t("Email address"), required: true,
        inner: ui.textInput({ id: "rc-email", type: "email", value: state.email, placeholder: _t("you@example.com") })
    });
    if (!isSMB) {
        html += ui.field({
            id: "rc-smb-usage", label: _t("Do you already use SimplyBook.me?"), required: true,
            inner: ui.radioGroup({ id: "rc-smb-usage", value: state.smbUsage, options: data.options(["Yes", "No", "Not sure"]) })
        });
    }
    html += ui.checkboxRow({
        id: "rc-results-consent", checked: state.resultsConsent,
        label: _t("Send me my revenue calculator results via email.") + ' <span class="rc-calc__required" aria-hidden="true">*</span>'
    });
    // checkboxRow() has no error slot of its own; showError() looks this one up by id.
    html += '<div class="rc-calc__field-error-slot" id="rc-results-consent-error" data-error-for="rc-results-consent"></div>';
    html += ui.checkboxRow({
        id: "rc-marketing-consent", checked: state.marketingConsent,
        label: _t("Send me tips and booking optimization emails from SimplyBook.me (typically 1-2 per month). You can unsubscribe anytime.")
    });
    html += '<p class="rc-calc__legal mb-3">' + _t("See our %link% for how we protect your data.").replace("%link%", '<a href="https://simplybook.me/en/policy" target="_blank" rel="noopener noreferrer" class="rc-calc__link">' + _t("Privacy Policy") + "</a>") + "</p>";
    html += ui.primaryButton({ id: "rc-submit-btn", label: _t("See my revenue report") });
    return ui.card(html);
}

function bind(container, state, actions) {
    container.querySelector("#rc-first-name").addEventListener("input", function (e) { state.firstName = e.target.value; });
    container.querySelector("#rc-email").addEventListener("input", function (e) { state.email = e.target.value; });
    var smbEl = container.querySelector('[data-radio-group="rc-smb-usage"]');
    if (smbEl) smbEl.querySelectorAll("[data-radio-value]").forEach(function (btn) {
        btn.addEventListener("click", function () { state.smbUsage = btn.getAttribute("data-radio-value"); actions.rerender(); });
    });
    var consentEl = container.querySelector("#rc-results-consent");
    consentEl.setAttribute("aria-describedby", "rc-results-consent-error");
    consentEl.addEventListener("change", function (e) { state.resultsConsent = e.target.checked; });
    container.querySelector("#rc-marketing-consent").addEventListener("change", function (e) { state.marketingConsent = e.target.checked; });

    container.querySelector("#rc-submit-btn").addEventListener("click", function () {
        var isSMB = state.d.bookingSystem === "SimplyBook.me";
        // The API validates the raw value (Assert\Email, html5 mode), so stray spaces must go first.
        state.email = String(state.email || "").trim();
        if (!validate.isEmail(state.email)) {
            actions.showError("rc-email", validate.isBlank(state.email)
                ? _t("Please enter your email and confirm you'd like to receive your results.")
                : _t("email_invalid_characters"));
            return;
        }
        if (!state.resultsConsent) {
            actions.showError("rc-results-consent", _t("Please confirm you'd like to receive your results by email."));
            return;
        }
        if (!isSMB && !state.smbUsage) {
            actions.showError("rc-smb-usage", _t("Please let us know if you already use SimplyBook.me."));
            return;
        }
        actions.submitLead();
    });
}

module.exports = { render: render, bind: bind };
